module.exports = __webpack_public_path__ + "img/TeamIcon.1bc88b58.svg";